import React, { useEffect, useState } from "react";
import rankText from "../../images/ranking-text.png";
import {tranColor,subName } from '../../utils/index'
import { Progress } from "antd";
import th1 from "../../images/top-header-1.png";
import tf1 from "../../images/top-footer-1.png";
import th2 from "../../images/top-header-2.png";
import tf2 from "../../images/top-footer-2.png";
import th3 from "../../images/top-header-3.png";
import tf3 from "../../images/top-footer-3.png";
import styles from "./style.less";
export default function RankingList({
  parentProps,
  fullData:list,
  handleClickItem,
}) {
  const [topThree, settopThree] = useState([]);
  const [leftList, setleftList] = useState([]);
  const detailRankData = (list) => {
    const currentTopThree = list.slice(0, 3);
    const currentLeftList = list.slice(3, list.length);
    settopThree(currentTopThree);
    setleftList(currentLeftList);
  };
  useEffect(() => {
    detailRankData(list);
  }, [list]);
  return (
    <div className={styles.rankContainer}>
      <img src={rankText} alt="text" className={styles.rankText} />
      <div className={styles.rankContext}>
        <div className={styles.topThree}>
          <div
            className={styles.topLeft}
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              handleClickItem({
                dataId:topThree[1]?.dataId,
                employId:topThree[1]?.dataId,
                employeeName:topThree[1]?.dataName,
                schemeCalculateId:topThree[1]?.schemeCalculateId
              })
            }}
          >
            <img src={th2} alt="th2" className={styles.topIcon} />
            <div className={styles.portrait}>
              {subName(topThree[1]?.dataName)}
            </div>
            <img src={tf2} alt="tf2" className={styles.bottomIcon} />
            <p className={styles.name}>{topThree[1]?.dataName}</p>
            <p className={styles.score}>
              {topThree[1]?.finalScore}
            </p>
          </div>
          <div
            className={styles.topCenter}
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              handleClickItem({
                dataId:topThree[0]?.dataId,
                employId:topThree[0]?.dataId,
                employeeName:topThree[0]?.dataName,
                schemeCalculateId:topThree[0]?.schemeCalculateId
              })
            }}
          >
            <img src={th1} alt="th1" className={styles.topIcon} />
            <div className={styles.topRankWarp}>
              <div className={styles.portrait}>
                {subName(topThree[0]?.dataName)}
              </div>
            </div>
            <img src={tf1} alt="tf1" className={styles.bottomIcon} />
            <p className={styles.name}>{topThree[0]?.dataName}</p>
            <p className={styles.score}>
              {topThree[0]?.finalScore}
            </p>
          </div>
          <div
            className={styles.topRight}
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              handleClickItem({
                dataId:topThree[2]?.dataId,
                employId:topThree[2]?.dataId,
                employeeName:topThree[2]?.dataName,
                schemeCalculateId:topThree[2]?.schemeCalculateId
              })
            }}
          >
            <img src={th3} alt="th3" className={styles.topIcon} />
            <div className={styles.portrait}>
              {subName(topThree[2]?.dataName)}
            </div>
            <img src={tf3} alt="tf3" className={styles.bottomIcon} />
            <p className={styles.name}>{topThree[2]?.dataName}</p>
            <p className={styles.score}>
              {topThree[2]?.finalScore}
            </p>
          </div>
        </div>
        <div className={styles.other}>
          {leftList.map((item, index) => (
            <div
              className={styles.otherRankItem}
              style={{
                cursor: "pointer",
              }}
              key={index}
              onClick={() => {
                handleClickItem({
                dataId:item?.dataId,
                employId:item?.dataId,
                employeeName:item?.dataName,
                schemeCalculateId:item?.schemeCalculateId
              })
              }}
            >
              {/* <div className={styles.num}>{item.order}</div> */}
              <div className={styles.num}>{index + 4}</div>
              <div
                className={styles.avtor}
                style={{
                  border: `1px solid ${tranColor(item.dataName).colorStr}`,
                  backgroundColor: tranColor(item.dataName).backColorStr,
                  color: tranColor(item.dataName).colorStr,
                }}
              >
                {subName(item.dataName)}
              </div>
              <div className={styles.name}>{item.dataName}</div>
              <div className={styles.pro}>
                <Progress
                  percent={item?.finalScore}
                  showInfo={false}
                  strokeWidth={4}
                />
              </div>
              <div className={styles.score}>
                {item?.finalScore}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
